export const locale = {
    lang: 'ds',
    data: {
        'Buttons': {
            'Plan': 'Planlæg',
            'Nonworkinghours': 'Ikke-arbejdstid',
        },
    }
}